import {useGeetestCaptcha} from './geetest-captcha';
import {useGoogleCaptcha} from './google-captcha';
import { useIpLookup } from './ip-lookup';

const usePlaceholderCaptcha = () => {
  return {
    captchaRendered: null,
    execute: () => {
      return Promise.resolve(null);
    },
    isExecutingRecaptcha: true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setShowCaptchaV2: (show: boolean) => {},
  };
};

export const useCaptcha = (action: 'login' | 'forgotPassword') => {
  const {
    data: { countryCode },
    loading,
  } = useIpLookup();

  const isGoogleBlockedCountry = countryCode?.toLowerCase() === 'cn' || countryCode?.toLowerCase() === 'cu';

  const placeholder = usePlaceholderCaptcha();
  const geetest = useGeetestCaptcha(loading || !isGoogleBlockedCountry);
  const google = useGoogleCaptcha(action, loading || isGoogleBlockedCountry);

  if (loading) {
    return placeholder;
  }

  if (isGoogleBlockedCountry) {
    return geetest;
  }

  return google;
};
